/* eslint-disable @typescript-eslint/ban-ts-comment */
import { store } from '@/store';
import { BaseCompoundFormFieldBuilder } from '.';
import { FormFieldType, OfficeHoursFormField } from '../typings';
import { setConditionalParentFields } from '../store';

export class OfficeHoursFormFieldBuilder extends BaseCompoundFormFieldBuilder<OfficeHoursFormField> {
  protected _type = FormFieldType.OfficeHours;
  protected _typeValue = FormFieldType.OfficeHours;
  // @ts-ignore
  private _days: OfficeHoursFormField['days'];
  // @ts-ignore
  private _showOnCall?: OfficeHoursFormField['showOnCall'];
  // @ts-ignore
  private _showClosed?: OfficeHoursFormField['showClosed'];

  constructor() {
    super();
  }

  public showOnCall(value: OfficeHoursFormField['showOnCall']): this {
    this._showOnCall = value;
    return this;
  }

  public showClosed(value: OfficeHoursFormField['showClosed']): this {
    this._showClosed = value;
    return this;
  }

  // TODO: Add method to add individual day
  public days(value: OfficeHoursFormField['days']): this {
    this._days = { ...value };

    const childrenIds = Object.values(this._days).flatMap(day => {
      return day.fields.map(field => field.fieldId);
    });

    store.dispatch(
      setConditionalParentFields({
        [this._fieldId]: childrenIds,
      }),
    );

    return this;
  }
}
